export const ShapeLineWidth: number = 4;
